<template>

    <div class="layout__container">
        <div class="component__customerhub layout__position-left">
            <div class="layout__container layout__padding-60px-0">
                <div class="component__upload-portal__leading colour__background-white">

                    <div class="text__align-center layout__margin__bottom-6px">

                        <img class="component__upload-cloud" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/uploadIcon.png"><br>

                        <h2 class="text__colour-teal layout__margin__top-10">Complete Photofixr Order Upload</h2>

                        <p class="layout__margin__top-10">Upload your photos here to complete photofixr orders</p>

                    </div>

                    <div class="component__upload-portal__leading-dropzone colour__background-white" id="dropzone"
                         @dragover.prevent="ondrag" @drop="ondrop" @dragleave="onleave" v-show="showUploadBool">
                        <h3 class="text__colour-teal text__align-center text__style-bold-900">Drag and drop<br>your
                            photos here</h3>

                        <el-button class="button-red layout__margin-2-05 button__base layout__margin__top-10"
                                   v-on:click="showUpload">Or
                            click to upload
                        </el-button>
                    </div>

                    <div class="layout__position-center" id="progress" v-show="showProgressBool">
                        <div class="layout__width-126px layout__height-126px layout__padding-clear layout__margin__top-20px">
                            <el-progress class="layout__position__absolute" type="circle" :width="126" status="exception"
                                         :percentage="uploadPercentage" color="#00859c"></el-progress>
                            <img class="component__upload-progress__icon__leading layout__position__absolute"
                                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/uploadProgress.png">
                        </div>
                    </div>

                    <div id="uploadError" v-show="showUploadErrorBool" class="text__align-center">
                        <h1 class="text__colour-red icon-error"></h1>
                        <h4>There's a problem!</h4><br>
                        <h3>Uploading Error, please try again</h3><br>
                        <el-button class="button-red layout__padding-10px button__base" v-on:click="tryAgain()">
                            Try again
                        </el-button>
                    </div>

                    <div id="successfulUpload" v-show="successfulUploadBool" class="text__align-center">
                        <h3 class="layout__padding-20-0 text__colour-teal">Completed Photos Uploaded Successfully</h3><br>
                        <el-button class="button-red layout__padding-10px button__base" v-on:click="tryAgain()">
                            Upload Photos
                        </el-button>
                    </div>
                </div>

                <input id="orderUpload" type="file" ref="orderUpload" v-on:change="buttonUpload()" multiple v-show=false>
            </div>
        </div>

        <!--<div class="layout__border__radius-10 layout__width-100 layout__position-left layout__padding-15-0 text__align-center text__colour-teal">-->
            <!--<h2>Photofixr File Upload</h2>-->
            <!--<p class="layout__padding__top-10px">Upload one or more completed Photofixr Photos</p>-->
        <!--</div>-->

        <!--TODO price for customer will be total -->

        <!--TODO price for others (to just be != customer will be total -->
        <!-- TODO there's a bunch of stuff with == PhotoEditor this needs to be everything inc. cs/editor/sarah's role-->

    </div>

</template>

<script>

    import Axios from 'axios';
    import EventBus from '../../../EventBus.js'
    import {Loading} from 'element-ui';
    import {axios} from '@/mixins/Axios.js';

    export default {
        name: "OrderDetails",
        mixins: [axios],
        props: ['id'],
        computed: {
            action: function () { // this allows dynamic changes locally based on the passed in param
            },
        },
        mounted() {
            if (this.role === 'PhotoEditor') {
                this.showFixerFeatures = true
            }
        },
        created() {
            this.isUserAuthorised();
        },
        data() {
            return {
                showFixerFeatures: false,
                showCustomerFeatures: false,
                successfulUploadBool: false,
                jobs: [],
                orderUpload: [],
                adminDisabled: true,
                jobRef: '',
                freetext: null,
                role: '',
                date: '',
                start: 1,
                end: 10,
                pagination: 10,
                accountType: '',
                showUploadBool: true,
                showProgressBool: false,
                showUploadErrorBool: false,
                uploadPercentage: 0,
                accounts: [
                    {account: 'online'},
                    {account: 'account'}
                ],
                download: false,
                jobStatus: null
            }
        },
        methods: {
            tryAgain() {
                this.uploadPercentage = 0;
                this.showUploadBool = true;
                this.showProgressBool = false;
            },
            ondrag() {
                document.getElementById('dropzone').className = 'component__upload-portal__leading-dropzone dragover';
                // event.preventDefault(); // just opening the file
                return false;

            },

            onleave() {
                console.log('on leave')
                document.getElementById('dropzone').className = 'component__upload-portal__leading-dropzone';
                // event.preventDefault(); // just opening the file
                return false;
            },

            ondrop(event) {
                console.log('onDrop')
                event.stopPropagation();
                event.preventDefault();

                console.log('making post to api')

                this.orderUpload = event.dataTransfer.files

                this.uploadCompletedOrders();
                document.getElementById('dropzone').className = 'component__upload-portal__leading-dropzone';
            },
            showUpload() {
                document.getElementById('orderUpload').click()
            },
            buttonUpload() {
                console.log('making post to api')

                this.orderUpload = this.$refs.orderUpload.files;

                this.uploadCompletedOrders();

            },
            updateOrders() {

                const url = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/?JobStatusFilter=Paid&JobStatusFilter=Not Started&JobStatusFilter=Started`
                Axios.get(url, this.returnAcceptHeader())
                    .then(response => {

                        this.jobs = response.data.reverse()
                        console.log(typeof this.jobs)

                    });
            },
            showOrderDetails(job) {
                console.log('job id ' + job.id)
                this.$router.push({
                    name: 'myPhotofixrOrders',
                    params: {jobId: job.sourceId, topLevelJob: job}
                })
            },
            uploadCompletedOrders() {

                console.log('upload completed orders')
                console.log(this.orderUpload.length)
                const formData = new FormData();

                for (let i = 0; i < this.orderUpload.length; i++) {
                    const file = this.orderUpload[i]
                    console.log('adding to form data ' + file.name);
                    formData.append(file.name, file, file.name)
                }

                this.showUploadBool = false;
                this.showProgressBool = true;

                const uploadOrderUrl = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs`

                Axios.put(uploadOrderUrl, formData, {
                    headers: {
                        "content-type": "multipart/form-data",
                        "Access-Control-Allow-Origin": "*",
                        "Authorization": "Bearer " + this.returnCookie("_token")
                    },
                    onUploadProgress: function(uploadEvent) {
                        this.uploadPercentage = Math.round(uploadEvent.loaded / uploadEvent.total * 100);
                    }.bind(this)
                })
                    .then(response => {
                        console.log(response)
                        this.showProgressBool = false;
                        this.successfulUploadBool = true;

                            this.sleep(3000).then(() => {
                                this.successfulUploadBool = false;
                                this.tryAgain()
                            })
                    })
                    .catch(error => {
                            console.log(error)
                            this.showUploadBool = false;
                            this.showProgressBool = false;
                            this.showUploadErrorBool = true;
                            this.leadFiles = [];
                    })
            },
            sleep(time) {
                return new Promise((resolve) => setTimeout(resolve, time));
            }
        },
        // mounted() {
        //     if (this.role === 'PhotoEditor') {
        //         this.showFixerFeatures = true
        //     }
        // },
        // created() {
        // },
        // data() {
        //     return {
        //         showFixerFeatures: false,
        //         showCustomerFeatures: false,
        //         jobs: [],
        //         orderUpload: [],
        //         adminDisabled: true,
        //         jobRef: '',
        //         freetext: null,
        //         role: '',
        //         date: '',
        //         start: 1,
        //         end: 10,
        //         pagination: 10,
        //         accountType: '',
        //         showUploadBool: true,
        //         showProgressBool: false,
        //         showUploadErrorBool: false,
        //         uploadPercentage: 0,
        //         accounts: [
        //             {account: 'online'},
        //             {account: 'account'}
        //         ],
        //         download: false,
        //         jobStatus: null
        //     }
        // },
        // props: ['id'],
        // computed: {
        //     action: function () { // this allows dynamic changes locally based on the passed in param
        //     },
        // },
    };
</script>
